<template>
  <ValidationObserver ref="rejectCandidate">
    <DialogFull :data="dialogSettings" @close="close">
      <template v-slot:dialog.body>
        <div class="container col-lg-6 col-sm-12 mt-6">
          <h2 class="pb-3">
            Why are you rejecting the following applications?
          </h2>
          <div class="d-flex">
            <div v-for="(worker, index) in applications" :key="index">
              <v-chip class="selected-worker-chip mr-2">
                <v-icon class="mr-1">mdi-account</v-icon>
                {{ worker.user | fullName }}
              </v-chip>
            </div>
          </div>
          <ValidationProvider
            v-slot="{ errors }"
            name="reason"
            rules="required"
          >
            <v-textarea
              aria-label="Reason"
              :error-messages="showValidationErrors ? errors : ''"
              v-model="reason"
              height="180"
              color="primary"
              placeholder="Add comment..."
              class="mt-2"
            />
          </ValidationProvider>
        </div>
      </template>
      <template v-slot:dialog.action>
        <ErrorButton @click.native="handleReject" :loading="isLoading">
          Reject Application(s)
        </ErrorButton>
      </template>
    </DialogFull>
  </ValidationObserver>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import pluralize from "pluralize";
import { size, map } from "lodash";
import { REJECT_CANDIDATE } from "@/store/modules/applications/actions";
import { createNamespacedHelpers } from "vuex";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import { POST_GLOBAL_MESSAGE } from "@/store/modules/global/action-types";
import { mapActions } from "vuex";

const { mapActions: mapApplicationActions } = createNamespacedHelpers(
  APPLICATION_NAMESPACE
);
export default {
  name: "RejectCandidates",
  components: {
    ErrorButton,
    DialogFull,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      reason: null,
      isLoading: false,
      showValidationErrors: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Reject Application(s)"
      };
    }
  },
  props: {
    isOpen: Boolean,
    applications: Array
  },
  methods: {
    ...mapActions({
      postGlobalMessage: POST_GLOBAL_MESSAGE
    }),
    ...mapApplicationActions({
      rejectCandidate: REJECT_CANDIDATE
    }),
    async handleReject() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.rejectCandidate.validate();
      if (isFormValid) {
        this.isLoading = true;
        const requests = map(this.applications, ({ id }) =>
          this.rejectCandidate({
            applicationId: id,
            reason: this.reason
          })
        );
        await Promise.all(requests);
        this.postSuccesMessage(size(requests));
        this.$emit("close", { success: true });
        this.isLoading = false;
      }
    },
    close() {
      this.$emit("close", { success: false });
    },
    postSuccesMessage(applicationNumber) {
      const message = {
        snackbar: true,
        type: "success",
        title: `You have rejected the ${pluralize(
          "application",
          applicationNumber
        )}`
      };
      this.postGlobalMessage(message);
    },
    pluralize,
    size
  }
};
</script>
